import { Anchor, Badge, Button, Group, Stack, Switch, Table, Text, Title } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../api/products';

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString();
}

export function ProductsPage() {
  const [showRetired, setShowRetired] = useState(false);
  const query = useProducts({ includeDeleted: showRetired });

  return (
    <Stack gap="lg">
      <Group justify="space-between" align="flex-end">
        <Title order={2}>Products</Title>
        <Button component={Link} to="/products/new" leftSection={<IconPlus size={16} />}>
          Create product
        </Button>
      </Group>

      <Group gap="md" align="flex-end" wrap="wrap">
        <Switch
          label="Show retired"
          checked={showRetired}
          onChange={(e) => setShowRetired(e.currentTarget.checked)}
        />
      </Group>

      <Table highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Code</Table.Th>
            <Table.Th>Display name</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>Assignments</Table.Th>
            <Table.Th>Created</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {(query.data ?? []).map((p) => {
            const retired = !!p.deletedAt;
            return (
              <Table.Tr key={p.id} style={retired ? { opacity: 0.5 } : undefined}>
                <Table.Td>
                  <Anchor component={Link} to={`/products/${p.id}`} size="sm">
                    {p.code}
                  </Anchor>
                </Table.Td>
                <Table.Td>{p.displayName}</Table.Td>
                <Table.Td>
                  {retired ? (
                    <Badge color="gray" variant="light">
                      retired
                    </Badge>
                  ) : (
                    <Badge color={p.status === 'active' ? 'green' : 'gray'} variant="light">
                      {p.status}
                    </Badge>
                  )}
                </Table.Td>
                <Table.Td>
                  <Badge color={p.assignment_count > 0 ? 'blue' : 'gray'} variant="light">
                    {p.assignment_count}
                  </Badge>
                </Table.Td>
                <Table.Td>{formatDate(p.createdAt)}</Table.Td>
                <Table.Td>
                  <Anchor component={Link} to={`/products/${p.id}/edit`} size="sm">
                    edit
                  </Anchor>
                </Table.Td>
              </Table.Tr>
            );
          })}
          {(query.data ?? []).length === 0 && !query.isPending && (
            <Table.Tr>
              <Table.Td colSpan={6}>
                <Text c="dimmed" ta="center">
                  No products yet.
                </Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
